import { find } from "lodash";
import { getTheme } from "PFCore/get_theme";

export const useInjectTheme = (theme, options = {}) => {
  const themeVars = getTheme(options.themeConfig, theme);

  const stylesheet = find(document.styleSheets, (item) => !item.href);
  Object.keys(themeVars).forEach((key) => stylesheet.cssRules[0].style.setProperty(key, themeVars[key]));
};
